import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { LookupService, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { DetailLedger, form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { RowState, PersonalityKind, TelephoneKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { takeUntil } from "rxjs/operators";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { PeopleInfo } from "projects/sepidz-web-framework/src/lib/models/peopleInfo.model";
import { BehaviorSubject, Observable } from "rxjs";
@Component({
  selector: "peopleinfo-form",
  templateUrl: "peopleinfo-form.component.html",
  styleUrls: ["peopleinfo-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleInfoFormComponent extends BaseFormComponent<PeopleInfo> {
  haserror: boolean = false;
  erroremessage: string;
  activeTabTitle: string;
  _Columns: form_control[];
  constructor(private lookupservice: LookupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.onDataStateChange = this.onDataStateChange.bind(this);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.activeTabTitle = undefined;
  }
  async ngOnInit() {
    if (!this.label) this.label = this.translate("ClientApp.GNR.PeopleInfo.PersonInformation");
    super.ngOnInit();
    if (!this.apiName) this.apiName = "PeopleInfo";
    this.setdefault();
    this.cd.markForCheck();
    this.selectorService.onSubmited.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      this.isValid();
      this.cd.markForCheck();
      if (x === true) setTimeout(() => this.selectorService.onSubmited.next(false), 100);
    });
  }

  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.model = new PeopleInfo();
        if (data) {
          this.model["Code"] = data as number;
          this.setValue("Code", data);
          this.setdefault();
        }
      });
  }

  setdefault() {
    if (this.isNewRow) {
      this.model.IsEmployee = false;
      this.model.IsBroker = false;
      this.model.IsCustomer = false;
      this.model.IsDetailLedger = false;
      this.model.IsSupplier = false;
      this.model.ContactKindByTelegram = false;
      this.model.ContactKindBySMS = false;
      this.model.ContactKindByEmail = false;
    }
    if (!this.model.PeopleInfoAddresss) {
      this.model.PeopleInfoAddresss = [];
    }
    if (!this.model.PeopleInfoTelephones) {
      this.model.PeopleInfoTelephones = [];
    }
    if (!this.model.PeopleInfoRelateds) {
      this.model.PeopleInfoRelateds = [];
    }

    if (!this.model.PersonalityKindId) {
      this.lookupservice.getLookupbyCode("GNR", "PersonalityKind", PersonalityKind.Real).subscribe((x: Lookup) => {
        this.model.PersonalityKindId = x.Id;
        this.model.PersonalityKindCode = x.Code;
        this.model.PersonalityKindTitle = x.Title;
        this.setValue("PersonalityKindId", this.model.PersonalityKindId);
        this.setValue("PersonalityKindCode", this.model.PersonalityKindCode);
        this.setValue("PersonalityKindTitle", this.model.PersonalityKindTitle);
      });
    }

    if (this.model) this.setColumnAttribute();

    this.selectorService.setDataStateChange("DetailLedgerId", this.onDataStateChange);
    this.isValid();

    this.cd.markForCheck();
  }

  getColumns() {
    this.orignalColumns.forEach((x) => {
      if (x.modelName === "CompanyKindId" || x.modelName === "CompanyName" || x.modelName === "NationalCode")
        x.required = this.model.PersonalityKindCode === PersonalityKind.Legal;
      if (x.modelName === "LastName" || x.modelName === "Party.LastName") x.required = this.model.PersonalityKindCode === PersonalityKind.Real;
    });
    var columns = this.columns.filter(
      (f) =>
        !this.model.PersonalityKindCode ||
        (this.model.PersonalityKindCode === PersonalityKind.Real && f.name !== "CompanyName" && f.name !== "CompanyKindId") ||
        (this.model.PersonalityKindCode === PersonalityKind.Legal && f.name !== "FirstName" && f.name !== "LastName")
    );
    columns.forEach((x) => {
      if (x.name === "BrandName") {
        if (this.model.PersonalityKindCode === PersonalityKind.Real) x.isFloat = 0;
        else x.isFloat = 1;
      }
    });
    columns = columns.sort((a, b) => a.order - b.order);
    columns.forEach((x) => {
      if (x.modelName === "CompanyKindId" || x.modelName === "CompanyName") x.required = this.model.PersonalityKindCode === PersonalityKind.Legal;
      if (x.modelName === "CompanyKindId" || x.modelName === "NationalCode") x.required = this.model.PersonalityKindCode === PersonalityKind.Legal;
    });
    columns.forEach((c) => {
      if (c.modelName === "Title") c.formVisible = this.apiName !== "CustomerInfo";
      if (c.modelName === "NationalCode") {
        if (this.model.PersonalityKindCode === PersonalityKind.Legal) {
          c.label = this.translate("ClientApp.GNR.PeopleInfo.NationalID");
          c.patternKey = "^[0-9]\\d{10}";
          if (this.formGroup) this.setValue(c.name, this.formGroup?.get(c.name)?.value, c.required, c.patternKey);
        } else {
          c.label = this.translate("ClientApp.GNR.PeopleInfo.NationalCode");
          c.patternKey = "^[0-9]\\d{9}";
          if (this.formGroup) this.setValue(c.name, this.formGroup?.get(c.name)?.value, c.required, c.patternKey);
        }
      }
      if (c.modelName === "Email") {
        c.patternKey = "^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+";
      }
    });
    columns = columns.filter((f) => f.formVisible);
    columns = columns.sort((a, b) => a.order - b.order);

    this._Columns = (columns as form_control[]).filter((f) => f.formVisible);
    this.cd.markForCheck();
  }

  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.getColumns();
  }
  onChanged(changedValue) {
    if (changedValue && changedValue.SystemName) {
      if (changedValue.SystemName && changedValue.Category === "CompanyKind") {
        this.model.CompanyKindTitle = (changedValue as Lookup).Title;
        this.model.CompanyKindCode = (changedValue as Lookup).Code;
        this.setValue("CompanyKindTitle", this.model.CompanyKindTitle);
        this.setValue("CompanyKindCode", this.model.CompanyKindCode);
      }
      if (changedValue.SystemName && changedValue.Category === "PersonalityKind") {
        this.model.PersonalityKindCode = (changedValue as Lookup).Code;
        this.model.PersonalityKindTitle = (changedValue as Lookup).Title;
        this.setValue("PersonalityKindCode", this.model.PersonalityKindCode);
        this.setValue("PersonalityKindTitle", this.model.PersonalityKindTitle);
      }
      this.getColumns();
      if (changedValue.SystemName && changedValue.Category === "PersonalityKind") {
        this.setValue("CompanyKindId", (changedValue as Lookup).Id, (changedValue as Lookup).Code === PersonalityKind.Legal);
        this.setValue("CompanyName", this.formGroup?.get("CompanyName")?.value, (changedValue as Lookup).Code === PersonalityKind.Legal);

        let patternKey: string = this._Columns.find((x) => x.modelName === "NationalCode").patternKey;
        this.setValue(
          "NationalCode",
          this.formGroup?.get("NationalCode")?.value,
          (changedValue as Lookup).Code === PersonalityKind.Legal,
          patternKey
        );
        this.setValue("LastName", this.formGroup?.get("LastName")?.value, (changedValue as Lookup).Code === PersonalityKind.Real);
        this.setValue("FirstName", this.formGroup?.get("FirstName")?.value, (changedValue as Lookup).Code === PersonalityKind.Real);
      }
    }
    //partyId is changed
    if (changedValue?.Number && changedValue?.hasOwnProperty("PhoneNumber")) {
      this.PartyAccountChange(changedValue);
    }
    this.isValid();
  }

  beforupdate() {
    this.cd.markForCheck();
    if (this.model.PersonalityKindCode === PersonalityKind.Legal) {
      this.setValue("LastName", this.formGroup?.get("CompanyName")?.value);
    }
    this.model.PeopleInfoAddresss = this.model.PeopleInfoAddresss.filter((x) => x.State !== RowState.Detached);
    this.model.PeopleInfoTelephones = this.model.PeopleInfoTelephones.filter((x) => x.State !== RowState.Detached);
  }

  chkeckSum() {
    let flag: boolean = true;
    const regex = /^\d{10}/;
    this.model.NationalCode = this.formGroup?.get("NationalCode")?.value;
    if (this.model.NationalCode && !regex.test(this.model.NationalCode)) return false;
    if (
      this.model.NationalCode === "0000000000" ||
      this.model.NationalCode === "1111111111" ||
      this.model.NationalCode === "2222222222" ||
      this.model.NationalCode === "3333333333" ||
      this.model.NationalCode === "4444444444" ||
      this.model.NationalCode === "5555555555" ||
      this.model.NationalCode === "6666666666" ||
      this.model.NationalCode === "7777777777" ||
      this.model.NationalCode === "8888888888" ||
      this.model.NationalCode === "9999999999" ||
      this.model.NationalCode.replace(this.model.NationalCode.substring(0, 1), "") === "" ||
      this.model.NationalCode === "1234567891" ||
      this.model.NationalCode === "1000000001" ||
      this.model.NationalCode === "0123456789"
    ) {
      return false;
    }
    var sum: number = 0;
    for (let i = 1; i < this.model.NationalCode.length; i++) {
      sum += Number(this.model.NationalCode[i - 1].toString()) * (11 - i);
    }
    var r = sum % 11;

    let num3: number = Number(this.model.NationalCode[9].toString());
    flag = (r === 0 && num3 === 0) || (r === 1 && num3 === 1) || num3 === 11 - r;
    return flag;
  }
  isValid() {
    this.erroremessage = undefined;
    this.haserror = true;

    if (this.formGroup?.get("NationalCode")?.value && this.model.PersonalityKindCode === PersonalityKind.Real && !this.chkeckSum()) {
      this.haserror = false;
      this.erroremessage = this.translate("ClientApp.GNR.PeopleInfo.NationalCodeNotValid");
      return this.haserror;
    }
    if (!this.formGroup?.get("NationalCode")?.value && this.model.PersonalityKindCode === PersonalityKind.Legal) {
      this.haserror = false;
      this.erroremessage = this.translate("ClientApp.GNR.PeopleInfo.NationalIDNotEntered");
      return this.haserror;
    }

    if (
      !this.model.PeopleInfoTelephones ||
      this.model.PeopleInfoTelephones.filter((x) => x.IsDefault && x.TelephoneKindCode !== TelephoneKind.Mobile).length > 0
    ) {
      this.haserror = false;
      this.erroremessage = this.translate("ClientApp.GNR.PeopleInfo.OnlyMobileDefault");
      return this.haserror;
    }

    return this.haserror;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
    this.isValid();
    setTimeout(() => {
      this.cd.detectChanges();
      this.cd.markForCheck();
    }, 100);
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  PartyAccountChange(event) {
    if (!event) {
      this.formGroup.controls["FirstName"].enable();
      this.formGroup.controls["LastName"].enable();
      this.formGroup.controls["Number"].enable();
    }
    if (event && event.Number && event.LastName) {
      this.model.Number = event.Number;
      this.formGroup.controls["Number"].setValue(event.Number);
      this.model.FirstName = event.FirstName;
      this.formGroup.controls["FirstName"].setValue(event.FirstName);
      this.model.LastName = event.LastName;
      this.formGroup.controls["LastName"].setValue(event.LastName);
      this.model.Description = event.Description;
      this.formGroup.controls["Description"].setValue(event.Description);

      if (this.formGroup.controls["FirstName"].value) this.formGroup.controls["FirstName"].disable();
      this.formGroup.controls["Number"].disable();
      this.formGroup.controls["LastName"].disable();
    }
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<DetailLedger>> {
    var abs = new BehaviorSubject<PagingDataResult<DetailLedger>>(null);
    let apiName: string = "DetailLedger/DetailLedgerWithKindId";
    this.httpCommonService
      .get<PagingDataResult<any>>(
        apiName + `/?detailLedgerKindId=${this.formGroup.controls["DetailLedgerKindId"].value}&searchValue=${searchValue}&skip=${skip}&take=${take}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x) => {
          if (x) abs.next(x);
        },
        (err) => {
          this.saveFailedHelper(err);
        }
      );
    return abs.asObservable();
  }
}
